import base = require("./base.dataservice");
import service = require("./breeze.entitymanager.service");

import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(PersonDataService.Id, PersonDataService);

    PersonDataService.$inject = ["entityManagerService", "breeze", "$log", "$q", "$http", "serviceConfig"];
}

@Injectable()
export class PersonDataService extends base.BaseDataService<Nema.Crew.Model.Person> implements IPersonDataService {

    private $http: ng.IHttpService;
    private serviceConfig;

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService,
        @Inject("$http") $http: ng.IHttpService,
        @Inject("serviceConfig") serviceConfig) {
        super(entityManagerService, breeze, $log, $q);

        this.$http = $http;
        this.serviceConfig = serviceConfig;
    }

    public static Id = "personDataService";

    protected get EntityName(): string {
        return "Person";
    }

    protected get EntitiesName(): string {
        return "Persons";
    }

    public getPersonsAndRelations() {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .orderBy('SortTag')
            .using(this.entityManager);

        var promise = entityQuery.execute()
            // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).execute());

        // TODO: Reconsider loading all the relations on ALL persons...
        return this.$q.all([
            promise,
            this.loadRelations()
        ]);
    }

    public getPersonsAndRelations2() {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .orderBy('SortTag')
            .using(this.entityManager);

        var promise = entityQuery.execute()
            // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).execute());

        // TODO: Reconsider loading all the relations on ALL persons...
        return this.$q.all([
            promise,
            this.loadRelations2()
        ]);
    }
    
    public savePersonImage(imageFile: File, personId: number): ng.IHttpPromise<any> {
        var url = this.serviceConfig.webApiUrl + "PersonService/" + personId + "/PersonImage?fileName=" + encodeURIComponent(imageFile.name);
        return this.$http.put(url, imageFile);
    }

    public deletePersonImage(personId: number): ng.IHttpPromise<any> {
        var url = this.serviceConfig.webApiUrl + "PersonService/" + personId + "/PersonImage";
        return this.$http.delete(url);
    }

    private loadRelations(): ng.IPromise<any> {

        var workplacesQuery = new this.breeze.EntityQuery().from('Workplaces').orderBy('SortTag').using(this.entityManager);
        var relationQuery = new this.breeze.EntityQuery().from('PersonWorkplaces').orderBy('FromDate').using(this.entityManager);

        return this.$q.all([
            workplacesQuery.execute(),
            relationQuery.execute()
        ]);
    }

    private loadRelations2(): ng.IPromise<Nema.Crew.Model.Person[]> {

        var workplacesQuery = new this.breeze.EntityQuery().from('Workplaces').orderBy('SortTag').using(this.entityManager);
        var workPlacesRelationQuery = new this.breeze.EntityQuery().from('PersonWorkplaces').orderBy('FromDate').using(this.entityManager);

        var workgroupsQuery = new this.breeze.EntityQuery().from('WorkGroups').using(this.entityManager);
        var workgroupsRelationQuery = new this.breeze.EntityQuery().from('WorkGroupPersons').using(this.entityManager);

        var activitiesQuery = new this.breeze.EntityQuery().from('Activities').using(this.entityManager);
        var activitiesTypeRelationQuery = new this.breeze.EntityQuery().from('ActivityTypes').using(this.entityManager);

        return this.$q.all([
            workplacesQuery.execute(),
            workPlacesRelationQuery.execute(),
            workgroupsQuery.execute(),
            workgroupsRelationQuery.execute(),
            activitiesQuery,
            activitiesTypeRelationQuery
        ]);
    }
    
    public deleteRelatedEntities(entity: Nema.Crew.Model.Person): Promise<void> {
        entity.PersonCompetences.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.PersonWorkplaces.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.PersonJobs.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.PersonRoles.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);

        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public getPersonWorkplace(personWorkplaceId: number): ng.IPromise<Nema.Crew.Model.PersonWorkplace> {
        return this.fetchEntityByKey("PersonWorkplace", personWorkplaceId);
    }

    public getPersonJobTitle(personJobTitleId: number): ng.IPromise<Nema.Crew.Model.PersonJob> {
        return this.fetchEntityByKey("PersonJob", personJobTitleId);
    }

    public getPersonRole(personRoleId: number): ng.IPromise<Nema.Crew.Model.PersonRole> {
        return this.fetchEntityByKey("PersonRole", personRoleId);
    }

    public getPersonCompetence(personCompetenceId: number): ng.IPromise<Nema.Crew.Model.PersonCompetence> {
        return this.fetchEntityByKey("PersonCompetence", personCompetenceId);
    }
    
    public newPersonWorkplace(personId: number, defaultWorkplaceId: number): Nema.Crew.Model.PersonWorkplace {
        return <Nema.Crew.Model.PersonWorkplace><any>this.entityManager.createEntity('PersonWorkplace', <Nema.Crew.Model.PersonWorkplace>{
            PersonId: personId,
            WorkplaceId: defaultWorkplaceId,
            FromDate: new Date()
        });
    }

    public newPersonJobTitle(personId: number, defaultJobTypeId: number): Nema.Crew.Model.PersonJob {
        return <Nema.Crew.Model.PersonJob><any>this.entityManager.createEntity('PersonJob', <Nema.Crew.Model.PersonJob>{
            PersonId: personId,
            JobTypeId: defaultJobTypeId,
            FromDate: new Date()
        });
    }

    public newPersonRole(personId: number, defaultRoleTypeId: number): Nema.Crew.Model.PersonRole {
        return <Nema.Crew.Model.PersonRole><any>this.entityManager.createEntity('PersonRole', <Nema.Crew.Model.PersonRole>{
            PersonId: personId,
            RoleTypeId: defaultRoleTypeId,
            From: new Date()
        });
    }

    public newPersonCompetence(personId: number, defaultCompetenceTypeId: number): Nema.Crew.Model.PersonCompetence {
        return <Nema.Crew.Model.PersonCompetence><any>this.entityManager.createEntity('PersonCompetence', <Nema.Crew.Model.PersonCompetence>{
            PersonId: personId,
            CompetenceTypeId: defaultCompetenceTypeId
        });
    }
    
    public saveFileContent(file: File, serviceUrl: string): ng.IHttpPromise<any> {
        var url = serviceUrl + "?fileName=" + encodeURIComponent(file.name);
        return this.$http.put(url, file);
    }
    
    public deleteFileContent(serviceUrl: string): ng.IHttpPromise<any> {
        return this.$http.delete(serviceUrl);
    }
}

export interface IPersonDataService extends base.IDataService<Nema.Crew.Model.Person> {
    getPersonsAndRelations();
    getPersonsAndRelations2();

    getPersonWorkplace(personWorkplaceId: number): ng.IPromise<Nema.Crew.Model.PersonWorkplace>;

    savePersonImage(imageFile: File, personId: number): ng.IHttpPromise<any>;

    deletePersonImage(personId: number): ng.IHttpPromise<any>;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/persons.dataservice.ts